import { Spin } from 'antd';
import { TreeChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface TreeNode {
  name: string;
  children?: TreeNode[];
  value?: number;
}
type Data = TreeNode[];

function TreeWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'tree', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <TreeChart data={data ?? []} />;
}

export const treeWidgetDef: WidgetDefinition = {
  type: 'tree',
  name: 'Tree Chart',
  description: 'Hierarchical tree structure',
  icon: 'ApartmentOutlined',
  category: 'chart',
  defaultTitle: 'Tree Chart',
  defaultConfig: {},
  minW: 4, minH: 5, defaultW: 6, defaultH: 7,
  component: TreeWidget,
  settingsSchema: { fields: [] },
};
